import React, { useEffect } from 'react'
import CargarActaAcuerdoPdf from '../../components/organismos/CargarActaAcuerdoPDF/CargarActaAcuerdoPdf'
import { Titulo} from "asocomponents"
import Layout from '../layouts/Layout'
import { useNavigate } from 'react-router-dom'

function ActaAcuerdo() {
  const navigate = useNavigate()
  const redireccionar=()=>navigate('/loguin')  

  //Valido si el usuario esta logueado sino se lo redirecciona al loguin
  useEffect(() => {
    const usuarioGuardado = sessionStorage.getItem('usuario')
    if (!usuarioGuardado) {
      redireccionar()
    }
  }, [])

  return (
    <Layout>
      <Titulo titulo="Procesar Acta Acuerdo"/>
      <CargarActaAcuerdoPdf/>
    </Layout>
  )
}

export default ActaAcuerdo